import * as React from 'react';

interface IPopupManagerContext {
    popup: IPopup;
    isPopupActive: boolean;
}
export const PopupManagerContext = React.createContext<IPopupManagerContext>({ popup: undefined, isPopupActive: false });
